<template>
	<div class="PassSet">
		<common-body aside="7">
			<div slot="commonMain" class="acct-page">
				<div class="acct-panel">
					<header class="acct-head">
						<div class="acct-head__titles">
							<h1 class="acct-head__title">个人中心</h1>
							<p class="acct-head__sub">管理账号资料与登录密码</p>
						</div>
						<nav class="acct-nav">
							<button
								type="button"
								class="acct-nav__item"
								:class="{ 'is-active': centerStatus == 1 }"
								data-url="/center"
								data-status="1"
								@click="goUrl"
							>用户信息</button>
							<button
								type="button"
								class="acct-nav__item"
								:class="{ 'is-active': centerStatus == 2 }"
								data-url="/passSet"
								data-status="2"
								@click="goUrl"
							>密码设置</button>
						</nav>
					</header>

					<section class="acct-section">
						<h2 class="acct-section__title">修改密码</h2>
						<p class="acct-section__desc">新密码需为 6～8 位数字或字母，且不能与旧密码相同。</p>
						<el-form :rules="rules" ref="passForm" label-position="top" :model="passForm" class="acct-form">
							<el-form-item label="旧密码" prop="pass">
								<el-input
									class="acct-input"
									type="password"
									show-password
									:clearable="clearable"
									placeholder="请输入旧密码"
									v-model="passForm.pass"
								></el-input>
							</el-form-item>
							<el-form-item label="新密码" prop="password">
								<el-input
									class="acct-input"
									type="password"
									show-password
									:clearable="clearable"
									placeholder="请输入新密码"
									v-model="passForm.password"
								></el-input>
							</el-form-item>
							<el-form-item label="确认密码" prop="psd">
								<el-input
									class="acct-input"
									type="password"
									show-password
									:clearable="clearable"
									placeholder="请再次输入新密码"
									v-model="passForm.psd"
								></el-input>
							</el-form-item>
							<div class="acct-actions">
								<button
									type="button"
									class="acct-btn acct-btn--primary"
									:class="{ 'is-loading': passStatus }"
									@click="submitForm('passForm')"
								>确认修改</button>
							</div>
						</el-form>
					</section>
				</div>
			</div>
		</common-body>
	</div>
</template>

<script>
	import { canAccessFrontRoute, readRuleList, resolveDefaultFrontRoute } from '@/utils/front-rules'

	export default {
		name: 'PassSet',
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入旧密码'));
					return
				}
				if (this.passForm.password !== '') {
					this.$refs.passForm.validateField('password');
				}
				callback();
			};
			var validatePass1 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入新密码'));
					return
				}
				if (value.length < 6 || value.length > 8) {
					callback(new Error('请输入6~8位数字或字母'));
					return
				}
				if (value == this.passForm.pass) {
					callback(new Error('新密码不能与旧密码一致'));
					return
				}
				if (this.passForm.psd !== '') {
					this.$refs.passForm.validateField('psd');
				}
				callback();
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入新密码'));
					return
				}
				if (value.length < 6 || value.length > 8) {
					callback(new Error('请输入6~8位数字或字母'));
					return
				}
				if (value !== this.passForm.password) {
					callback(new Error('两次输入密码不一致!'));
					return
				}
				callback();
			};
			return {
				centerStatus: 2,
				clearable: !0,
				userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
				passStatus: !1,
				passForm: {
					pass: "",
					password: "",
					psd: ""
				},
				rules: {
					pass: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					password: [{
						validator: validatePass1,
						trigger: 'blur'
					}],
					psd: [{
						validator: validatePass2,
						trigger: 'blur'
					}]
				},
			}
		},
		created() {
			if (!canAccessFrontRoute('/passSet', readRuleList())) {
				const target = resolveDefaultFrontRoute(readRuleList())
				this.$router.replace(target || '/')
				return
			}
		},
		methods: {
			resetPassForm() {
				this.passForm.pass = ''
				this.passForm.password = ''
				this.passForm.psd = ''
				this.$nextTick(() => {
					if (this.$refs.passForm) this.$refs.passForm.clearValidate()
				})
			},
			submitForm(passForm) {
				let that = this
				if (that.passStatus) return
				that.$refs[passForm].validate((valid) => {
					if (!valid) return false
					that.passStatus = !0
					that.$fetch('addons/hlm/api.User/up_password', that.passForm).then(function(res) {
						if (res.code == 1) {
							that.resetPassForm()
							that.$message({
								message: '修改成功',
								type: 'success',
								duration: 1500,
								center: !0
							});
						}
						that.passStatus = !1
					}).catch(function() {
						that.passStatus = !1
					})
				});
			},
			goUrl(e) {
				let that = this, status = e.currentTarget.dataset.status, url = e.currentTarget.dataset.url
				if (status != that.centerStatus) {
					that.$router.replace(url)
				}
			},
		}
	};
</script>

<style src='../assets/css/passSet.css'>
	/* px2rem能正常转换 */
</style>
